import * as tslib_1 from "tslib";
import { HttpInterceptorService, RESTService } from '@covalent/http-deprec';
import { environment } from '../../../../environments/environment';
import { catchError, map } from "rxjs/operators";
import { throwError } from "rxjs/index";
var BenutzerService = /** @class */ (function (_super) {
    tslib_1.__extends(BenutzerService, _super);
    function BenutzerService(http) {
        var _this = _super.call(this, http, {
            baseUrl: "" + environment.apiHost,
            path: 'makpak/getalluserinfo'
        }) || this;
        _this.http = http;
        return _this;
    }
    BenutzerService.prototype.getAllUsers = function () {
        console.log("alle User aus DB-Tabelle BENUTZER auslesen !");
        return _super.prototype.get.call(this, "").pipe(map(function (res) {
            return res;
        }));
    };
    BenutzerService.prototype.deleteUser = function (benutzerId) {
        return this.http.delete("" + environment.apiHost + '/makpak/userdelete/' + benutzerId).pipe(map(function (res) { return res.json(); }), catchError(function (error) { return throwError(error); }), map(function (result) {
            console.log("User gelöscht ");
            if (result != null) {
                return result;
            }
            console.log(result);
        }));
    };
    BenutzerService.prototype.updateUser = function (userinfo) {
        return this.http.post("" + environment.apiHost + '/makpak/userupdate', userinfo).pipe(map(function (res) { return res.json(); }), catchError(function (error) { return throwError(error); }), map(function (res) {
            console.log("User angelegt / aktualisiert");
            if (res != null) {
                return res;
            }
            console.log(res);
        }));
    };
    BenutzerService.prototype.postMeinKonto = function (meinkonto) {
        return this.http.post("" + environment.apiHost + '/makpak/meinkontoupdate', meinkonto).pipe(map(function (res) { return res.json(); }), catchError(function (error) { return throwError(error); }), map(function (res) {
            console.log("mein Konto aktualisiert");
            if (res != null) {
                return res;
            }
            console.log(res);
        }));
    };
    BenutzerService.prototype.getMeinKonto = function () {
        return this.http.get("" + environment.apiHost + '/makpak/meinkontoleg').pipe(map(function (res) { return res.json(); }), catchError(function (error) { return throwError(error); }), map(function (res) {
            console.log("User angelegt / aktualisiert");
            if (res != null) {
                return res;
            }
            console.log(res);
        }));
    };
    BenutzerService.prototype.getAllVtnrs = function () {
        return this.http.get("" + environment.apiHost + '/makpak/meinkonto/vtnrs').pipe(map(function (res) { return res.json(); }), catchError(function (error) { return throwError(error); }), map(function (res) {
            console.log("Vtnrs zu Bensl geholt");
            if (res != null) {
                return res;
            }
            console.log(res);
        }));
    };
    BenutzerService.prototype.getVtnrAdress = function (vtnr) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.get("" + environment.apiHost + '/makpak/meinkonto/vtnrAdress?vtnr=' + vtnr).toPromise()];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.json()];
                }
            });
        });
    };
    BenutzerService.prototype.getSystemRoles = function () {
        return this.http.get("" + environment.apiHost + '/makpak/meinkonto/systemRoles').pipe(map(function (res) { return res.json(); }), catchError(function (error) { return throwError(error); }), map(function (res) {
            console.log("System Roles wurden ausgelesen");
            if (res != null) {
                return res;
            }
            console.log(res);
        }));
    };
    BenutzerService.prototype.checkRequestId = function () {
        return this.http.get("" + environment.apiHost + '/makpak/meinkontorequest').pipe(map(function (res) { return res.json(); }), catchError(function (error) { return throwError(error); }), map(function (res) {
            if (res != null) {
                return res;
            }
            console.log(res);
        }));
    };
    BenutzerService.prototype.checkVtnr = function (vermittlernr, plz) {
        var formData = new FormData();
        formData.append("vermittlernr", vermittlernr);
        formData.append("plz", plz);
        return this.http.post("" + environment.apiHost + '/makpak/meinkonto/vermittlernummer', formData).pipe(map(function (res) { return res.json(); }), catchError(function (error) { return throwError(error); }), map(function (res) {
            console.log("vermittlernummert");
            if (res != null) {
                return res;
            }
            console.log(res);
        }));
    };
    BenutzerService.prototype.postSendeNewRoles = function (berechtigungen, vermittlernr, deletedberechtigungen) {
        var formData = new FormData();
        formData.append("berechtigungen", berechtigungen);
        formData.append("vermittlernr", vermittlernr);
        formData.append("deletedberechtigungen", deletedberechtigungen);
        return this.http.post("" + environment.apiHost + '/makpak/meinkonto/absenden', formData).pipe(map(function (res) { return res.json(); }), catchError(function (error) { return throwError(error); }), map(function (res) {
            console.log("mein Konto aktualisiert");
            if (res != null) {
                return res;
            }
            console.log(res);
        }));
    };
    BenutzerService.prototype.postGenehmiger = function (berechtigungen, vermittlernr, deletedberechtigungen) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var formData, res;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formData = new FormData();
                        formData.append("berechtigungen", berechtigungen);
                        formData.append("vermittlernr", vermittlernr);
                        formData.append("deletedberechtigungen", deletedberechtigungen);
                        return [4 /*yield*/, this.http.post("" + environment.apiHost + '/makpak/meinkonto/msn', formData).toPromise()];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res];
                }
            });
        });
    };
    return BenutzerService;
}(RESTService));
export { BenutzerService };
